import { render, staticRenderFns } from "./ComposeMessage.vue?vue&type=template&id=55fad866&scoped=true"
import script from "./ComposeMessage.vue?vue&type=script&lang=js"
export * from "./ComposeMessage.vue?vue&type=script&lang=js"
import style0 from "./ComposeMessage.vue?vue&type=style&index=0&id=55fad866&prod&lang=scss"
import style1 from "./ComposeMessage.vue?vue&type=style&index=1&id=55fad866&prod&lang=scss&scoped=true"
import style2 from "vue-search-select/dist/VueSearchSelect.css?vue&type=style&index=2&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fad866",
  null
  
)

export default component.exports